
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ProductVariantModel } from './Entities.GormCrm.ProductVariant';
import { VariantListOptionModel } from './Entities.GormCrm.VariantListOption';
import { Model, ModelProperty } from 'models/Model';


export class ProductVariantsOptionModel extends Model<ProductVariantsOptionModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'variantId', type: 'guid', languageString: 'productVariantsOption.property.variantId' },
		{ name: 'variantOptionId', type: 'guid', languageString: 'productVariantsOption.property.variantOptionId' },
		{ name: 'variant', type: 'ProductVariantModel', languageString: 'productVariantsOption.property.variant', isHidden: true, isObject: true, new: () => { return new ProductVariantModel }, properties: () => { return ProductVariantModel.classProperties } },
		{ name: 'variantOption', type: 'VariantListOptionModel', languageString: 'productVariantsOption.property.variantOption', isHidden: true, isObject: true, new: () => { return new VariantListOptionModel }, properties: () => { return VariantListOptionModel.classProperties } }
	];
	[key: string]: any;
	
	public variantId?: string;
	public variantOptionId?: string;
	public variant?: ProductVariantModel;
	public variantOption?: VariantListOptionModel;
    
	constructor(){
		super();
		this.variantId = undefined;
		this.variantOptionId = undefined;
		this.variant = undefined;
		this.variantOption = undefined;
		
	}
	getProperties(){
		return ProductVariantsOptionModel.classProperties;
	}
}

